import { Button, Col, Radio, Row, Spin } from "antd";
import Item from "../Items/ExchangeModal/Item";

function AcceptedOffer({
  typeItems,
  loadingProfit,
  loading,
  invalid,
  profit,
  profitPercentage,
  commission,
  commissionPercentage,
  managementFees,
  priceAfterDeduction,
  onSelect,
  onInputChange,
  collectionTypes,
  selectedCollectionTypeId,
  onCollectionTypeChange,
  t,
}) {
  return (
    <>
      <h2 className="notificationModal__title text-center">
        {t("notificationModal.acceptOffer")}
      </h2>
      <Row gutter={24}>
        <Col span={24}>
          <div className="notificationModal__items-holder pe-3 d-flex flex-column">
            {typeItems ? (
              typeItems.map((item) => (
                <Item
                  checked={item.isSelected}
                  key={item.orderId}
                  item={item}
                  onSelect={onSelect}
                  onInputChange={onInputChange}
                  type={"accept-offer-item"}
                />
              ))
            ) : (
              <div className="d-flex py-3 justify-content-center">
                <Spin />
              </div>
            )}
          </div>
          <div className="notificationModal__summary">
            <p className="notificationModal__pill">
              {t("notificationModal.profitPercentage")}:{" "}
              {loadingProfit ? (
                <Spin size="small" />
              ) : (
                `${!invalid ? profitPercentage : 0} %`
              )}
            </p>
            <p className="notificationModal__pill">
              {t("notificationModal.commissionPercentage")}:{" "}
              {loadingProfit ? (
                <Spin size="small" />
              ) : (
                `${!invalid ? commissionPercentage : 0} %`
              )}
            </p>
            <p className="notificationModal__pill">
              {t("notificationModal.profit")}:{" "}
              {loadingProfit ? (
                <Spin size="small" />
              ) : (
                `${!invalid ? profit : 0} ${t("notificationModal.egp")}`
              )}
            </p>
            <p className="notificationModal__pill">
              {t("notificationModal.commission")}:{" "}
              {loadingProfit ? (
                <Spin size="small" />
              ) : (
                `${!invalid ? commission : 0} ${t("notificationModal.egp")}`
              )}
            </p>
            {/* <p className="mb-1 main-dark-text fw-500 fsize-11">
              {t("home.itemModal.managementFees")}:{" "}
              {loadingProfit ? (
                <Spin />
              ) : (
                `${!invalid ? managementFees : 0} ${t("notificationModal.egp")}`
              )}
            </p> */}
            <p className="notificationModal__pill notificationModal__pill--full">
              {t("notificationModal.priceAfterCommissionDeduction")}:{" "}
              {loadingProfit ? (
                <Spin size="small" />
              ) : (
                `${!invalid ? priceAfterDeduction : 0} ${t(
                  "notificationModal.egp",
                )}`
              )}
            </p>
          </div>
        </Col>

        {/* <Col span={24}>
          <p
            className="mb-3 text-center text-danger"
            style={{ fontSize: "14px" }}
          >
            {t("notificationModal.message")}
          </p>
        </Col> */}

        <Col span={24}>
          <h3 className="notificationModal__payment-title">
            {t("notificationModal.selectPaymentMethod")}
          </h3>
          {collectionTypes?.length > 0 && (
            <Radio.Group
              className="notificationModal__payment-radios w-100"
              value={selectedCollectionTypeId}
              onChange={(e) => onCollectionTypeChange(e.target.value)}
            >
              {collectionTypes.map((type) => (
                <Radio key={type.id} value={type.id}>
                  {type.name}
                </Radio>
              ))}
            </Radio.Group>
          )}
        </Col>

        <div className="w-100 d-flex justify-content-center align-items-center pt-2">
          <Button
            htmlType="submit"
            loading={loading}
            disabled={
              !typeItems ||
              invalid ||
              loadingProfit ||
              !selectedCollectionTypeId ||
              loading
            }
            className="notificationModal__accept-btn"
          >
            {t("notificationModal.accept")}
          </Button>
        </div>
      </Row>
    </>
  );
}

export default AcceptedOffer;
